export const positiveIntValidation = '^[0-9]*$';
